import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=5e72600b&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"
import style0 from "./Business.vue?vue&type=style&index=0&id=5e72600b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72600b",
  null
  
)

export default component.exports